import { render, staticRenderFns } from "./navigationGF.vue?vue&type=template&id=63bad73d&scoped=true"
import script from "./navigationGF.vue?vue&type=script&lang=js"
export * from "./navigationGF.vue?vue&type=script&lang=js"
import style0 from "./navigationGF.vue?vue&type=style&index=0&id=63bad73d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bad73d",
  null
  
)

export default component.exports